import { render, staticRenderFns } from "./WarehouseUnloadDetails.vue?vue&type=template&id=65c6a638&"
import script from "./WarehouseUnloadDetails.vue?vue&type=script&lang=js&"
export * from "./WarehouseUnloadDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports